
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyPilarConeUp as ObiBuoyPilarConeUpElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-pilar-cone-up.js';
 
 
 

 
 export const ObiBuoyPilarConeUp = createComponent({
   react: React,
   tagName: 'obi-buoy-pilar-cone-up',
   elementClass: ObiBuoyPilarConeUpElement,
   events: {
     
   }
  });
 
 